export default __webpack_public_path__ + "static/media/AuthApp.84d422be.mp4";